module.exports = __webpack_public_path__ + "img/ios-help-buoy.07ac0589.svg";